import keyMirror from 'keymirror';

export const episodeDetailsActionTypes = keyMirror({
	GET_EPISODE_DETAILS_REQUEST: null,
	GET_EPISODE_DETAILS_SUCCESS: null,
	GET_EPISODE_DETAILS_ERROR: null,
	CLEAN_EPISODE_DETAILS_STATE: null,
	ADD_ROOM_REQUEST: null,
	ADD_ROOM_SUCCESS: null,
	ADD_ROOM_ERROR: null,
	ADD_HINT_REQUEST: null,
	ADD_HINT_SUCCESS: null,
	ADD_HINT_ERROR: null,
	UPDATE_ROOM_REQUEST: null,
	UPDATE_ROOM_SUCCESS: null,
	UPDATE_ROOM_ERROR: null,
	UPDATE_HINT_REQUEST: null,
	UPDATE_HINT_SUCCESS: null,
	UPDATE_HINT_ERROR: null,
});
